import firebase from 'firebase/app';
import moment from 'moment';

const db = () => firebase.database().ref('stockStatus');

let _tradingItems = [];
const stockLists = async () => {
  if (_tradingItems.length) return _tradingItems;

  _tradingItems = await firebase
    .database()
    .ref('trading')
    .orderByChild('codeName')
    .once('value')
    .then(snapshot => snapshot.val());

  return _tradingItems;
};

export const ProfitService = {
  stockLists,
  fetchByDate: (date = new Date()) => {
    const path = moment(date).format('YYYY/MM/DD');
    return db()
      .child(path)
      .once('value')
      .then(snapshot => {
        return snapshot.val() || [];
      });
  },
  update: async (date, data) => {
    const path = moment(date).format('YYYY/MM/DD');
    const ref = db().child(path);
    const prev = await ref.once('value').then(snapshot => snapshot.val() || []);
    const idx = prev.findIndex(item => item.id === data.id);
    if (idx > -1) prev[idx] = data;
    else prev.unshift(data);

    await ref.set(prev);
    return prev;
  },
  remove: async (date, data) => {
    const path = moment(date).format('YYYY/MM/DD');
    const ref = db().child(path);
    const prev = await ref.once('value').then(snapshot => snapshot.val() || []);
    const idx = prev.findIndex(item => item.id === data.id);
    if (idx > -1) {
      prev.splice(idx, 1);
      await ref.set(prev);
    }
    return prev;
  }
};
